import { atomWithLocalStorage } from '../../utils/persistence';

export const lastSelectedFolderAtom = atomWithLocalStorage('lastSelectedFolder');
